import ReactGA from 'react-ga4'
const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID
export const gaActions = {
  cycleEventClick: 'cycle_event_click',
  documentClick: 'document_click',
  featureClick: 'feature_click',
  firmwareClick: 'firmware_click',
  videoClick: 'video_click',
}
export const gaCategories = {
  calendarPage: 'Calendar Page',
  colteneStorePage: 'Coltene Store Page',
  dashboardPage: 'Dashboard Page',
  documentsPage: 'Documents Page',
  firmwarePage: 'Firmware Page',
  instrumentReprocessingReportsPage: 'Instrument Reprocessing Reports Page',
  instrumentTrackingPage: 'Instrument Tracking Page',
  myAccountPage: 'My Account Page',
  productPage: 'Product Page',
  productSelection: 'Product Selection',
  remoteAccessPage: 'Remote Access Page',
  sparepartsPage: 'Spareparts Page',
  troubleshootingPage: 'Troubleshooting Page',
  videosPage: 'Videos page',
}
export const initializeGA = () => {
  if (measurementId) {
    ReactGA.initialize(measurementId)
    return
  }
  console.log('GA4 Measurement ID is not defined')
}
export const trackEvent = ({ action, category, label }) => {
  ReactGA.event({
    action,
    category,
    label,
  })
}